import React from 'react'
import BlueHeading from '../other/common/BlueHeading';
import Heading from '../common/ui/Heading';
import servicedutyImg from '../../assets/images/webp/service-duty.webp'
const ServiceDuty = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="flex items-center max-w-[1140px] justify-between mx-auto max-xl:gap-8 max-lg:flex-wrap">
          <div className="max-w-[490px] max-lg:max-w-full">
            <BlueHeading lineClassOne="!hidden" text="About Us" />
            <Heading
              children="Service is True Duty"
              className="max-w-[468px]"
            />
            <p className="text-[#010101] text-xl font-medium leading-[150%] py-[13px]">
              "When the purpose is not just success but service to society –
              true leadership is born."
            </p>
            <p className="text-[#686868] font-normal text-base leading-[150%]">
              Shri Deepak Ji is not only a successful entrepreneur and
              motivational leader but also a sensitive and socially aware
              philanthropist. Over the years, he has contributed to various
              sectors of society, including education, women's empowerment,
              environmental protection, and youth guidance.
            </p>
          </div>
          <img
            src={servicedutyImg}
            alt="service"
            className="w-full max-w-[614px] max-lg:max-w-full"
          />
        </div>
      </div>
    </>
  );
}

export default ServiceDuty